var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58003 13.0227C0.708835 13.0227 0 12.3138 0 11.4427V6.15982C0 5.28863 0.708835 4.57977 1.58003 4.57977H9.04702C9.91832 4.57977 10.6272 5.28863 10.6272 6.15982V11.4427C10.6272 12.3139 9.91823 13.0227 9.04702 13.0227H1.58003ZM1.57986 5.46103C1.19505 5.46145 0.881681 5.77493 0.881241 6.15965V11.4427C0.881681 11.8276 1.19514 12.141 1.57986 12.1415H9.04702C9.43246 12.1415 9.746 11.828 9.746 11.4427V6.15982C9.746 5.77449 9.43244 5.46103 9.04702 5.46103H1.57986Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31339 10.6205C5.19655 10.6204 5.08452 10.5739 5.00189 10.4913C4.91925 10.4087 4.87277 10.2967 4.87264 10.1799V8.65005C4.87277 8.53324 4.91923 8.42124 5.00182 8.33863C5.08441 8.25602 5.19639 8.20954 5.31321 8.20938C5.43003 8.20951 5.54203 8.25599 5.62463 8.3386C5.70723 8.42122 5.75368 8.53323 5.75379 8.65005V10.1798C5.75379 10.2975 5.70808 10.4081 5.62485 10.4913C5.54163 10.5746 5.43098 10.6204 5.31339 10.6205ZM7.58218 4.91985V3.38882C7.58218 2.14172 6.56759 1.12721 5.32058 1.12721C4.07347 1.12721 3.05887 2.14172 3.05887 3.38882V4.91985H2.17773V3.38882C2.17773 1.65585 3.58761 0.245972 5.32066 0.245972C7.05362 0.245972 8.46342 1.65585 8.46342 3.38882V4.91985H7.58218Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30941 8.83157C4.85957 8.83115 4.49389 8.46494 4.49414 8.0151C4.49423 7.565 4.86026 7.19897 5.30993 7.19897C5.75995 7.19906 6.12589 7.56516 6.12579 8.015C6.12545 8.46582 5.7596 8.83157 5.3101 8.83157H5.30942H5.30941Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.92058a6f1706c39bae06c798b7252b1c.svg";
export { ForwardRef as ReactComponent };